import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Master Activity Pack',
  value: '12',
  desc: 'A massive collection of over 150 print-ready worksheets designed specifically for High School Research Methods classrooms. Every worksheet is aligned to a specific stage of the research process.',
  benefit: 'No preparation needed. Print, distribute and teach.'
}, {
  id: '02',
  title: 'Advanced Assessment Pack',
  value: '15',
  desc: 'A powerful collection of over 100 ready-to-use assessments, quizzes, tests and evaluation tools designed exclusively for Research Methods teachers. Covers every stage of the research process.',
  benefit: 'Never build an exam from scratch under pressure again.'
}, {
  id: '03',
  title: 'Premium Research Methods Glossary',
  value: '10',
  desc: 'A comprehensive, academically rigorous reference tool containing over 200 essential Research Methods terms and concepts written in clear, student-friendly academic English.',
  benefit: 'No more class time lost defining terms from scratch.'
}, {
  id: '04',
  title: 'Annual Research Project Templates',
  value: '12',
  desc: 'A complete system of over 120 print-ready research project templates that guide students step by step through the entire research process. Includes semester-by-semester timelines.',
  benefit: 'No more lost students. No more incomplete projects. No more last-minute submissions.'
}, {
  id: '05',
  title: 'Cheat-Proof Rubric Library',
  value: '12',
  desc: 'A professionally designed collection of over 80 evaluation rubrics built exclusively for Research Methods teachers who are tired of inconsistent grading and academic dishonesty.',
  benefit: 'Students know exactly what is expected from day one.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Included at no extra cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-19">
            🎁 The 5 Strategic Bonuses
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-21">
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22">
                BONO {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-26">
                <span className="text-gray-400 text-sm" data-id="element-27">
                  Real value:{' '}
                  <span className="line-through" data-id="element-28">${bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-29">→ FREE</span>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32">
          <p className="text-gray-300 mb-2" data-id="element-33">Total value of the 5 bonuses</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-34">$61.00</p>
          <p className="text-lg text-white mb-2" data-id="element-35">Your price today</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36">🎁 FREE</p>
          <p className="text-sm text-gold-light" data-id="element-37">
            Only included in this offer.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}